import { CommonDialogs } from "@mcleod/common";
import { Api, StringUtil, UrlUtil, LogManager } from "@mcleod/core";
import { AutogenLayoutContinuousMove } from "./autogen/AutogenLayoutContinuousMove";

const log = LogManager.getLogger("portal-carrier.offer.ContinuousMove");

export class ContinuousMove extends AutogenLayoutContinuousMove {

    override async onLoad() {
        const props = UrlUtil.getPropsFromUrl(document.location.search);
        this.labelResponse.busy = true;
        Api.post("portal/carrier/carrier-continuous-move", { token: props.token }).then(response => {
            log.debug({ response });
            if (!StringUtil.isEmptyString(response.data[0].success)) {
                this.labelResponse.text = response.data[0].success
            }
        }).catch(err => {
            this.labelResponse.text = "Error sending email"
            CommonDialogs.showError(err);
        }).finally(() => this.labelResponse.busy = false);
    }
}
